// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html{
  font-size: 14px;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.note-text {
  font-size: small;
  color: grey;
  font-style: italic;
}

body{
    background-color: #FAFAFA;
}

/* @media (min-width: 769px) {
    .navbar-top-lg-lg {
      padding-top: 0 !important;
    }
  } */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;;KAIK","sourcesContent":["html{\r\n  font-size: 14px;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n.note-text {\r\n  font-size: small;\r\n  color: grey;\r\n  font-style: italic;\r\n}\r\n\r\nbody{\r\n    background-color: #FAFAFA;\r\n}\r\n\r\n/* @media (min-width: 769px) {\r\n    .navbar-top-lg-lg {\r\n      padding-top: 0 !important;\r\n    }\r\n  } */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
